<template>
  <div class="container mb-5">
    <v-data-table
      :headers="headers"
      :search="search"
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :server-items-length="totalItems"
      :page.sync="page"
      class="elevation-1 mt-5"
    >
      <template v-slot:top>
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              label="Search Indentity Number"
              class="mx-4 col-12 col-lg-12"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn class="mx-4" depressed color="primary" @click="searchBtn">
              Search
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <detail-view :detail="item"></detail-view>
      </template>
      <template v-slot:[`item.StatusEnq`]="{ item }">
        <v-chip :color="getColor(item.StatusEnq)" dark>
          {{ item.StatusEnq == 1 ? "Match" : "No Match" }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

 
<script>
import axios from "axios";
import DetailView from "./components/DetailView.vue";
export default {
  components: { DetailView },
  name: "ListAppEnq",

  data: () => ({
    dialogDetail: false,
    search: "",
    totalItems: 0,
    page: 1,
    itemsPerPage: 5,
    headers: [
      {
        text: "Actions",
        value: "actions",
        sortable: false,
      },
      { text: "Status Enq", value: "StatusEnq", sortable: false },
      { text: "Reference Number", value: "IdMessage" },
      { text: "Identity Type", value: "IdentityTypeDesc" },
      { text: "Identity Number", value: "IdentityNumber" },
      { text: "Name As Id", value: "NameAsId" },
      { text: "Gender", value: "Gender" },
      { text: "Created At", value: "created_at" },
    ],
    items: [],
    dataDetail: "",
  }),

  created() {
    this.getListNewAppEnq(1, 5);
  },

  watch: {
    page: function (val) {
      this.getListNewAppEnq(val, this.itemsPerPage);
    },
    itemsPerPage: function (val) {
      if (val == -1) {
        this.getListNewAppEnq(1, this.totalItems);
      } else {
        this.getListNewAppEnq(this.page, val);
      }
    },
  },

  methods: {
    getColor(status) {
      if (status == 0) {
        return "red";
      } else {
        return "green";
      }
    },

    async getListNewAppEnq(pageNumber, pageSize) {
      // axios.get('http://127.0.0.1:8000/api/newapp').then(res => {
      //   this.items = res.data;
      // })
      let params = { "page[number]": pageNumber, "page[size]": pageSize };
      await this.$store.dispatch("finance_click/list", params);

      if (
        (await this.$store.getters["finance_click/list"]) &&
        (await this.$store.getters["finance_click/list"].length) != 0
      ) {
        this.items = await this.$store.getters["finance_click/list"];
        this.totalItems = await this.$store.getters["finance_click/listTotal"];
      }

      // console.log("LIST_NEW_APP", this.items);
    },

    getLastDate() {
      return this.items[0].created_at;
    },

    async searchBtn() {
      if (this.search !== "") {
        let params = { "filter[identity_number]": this.search };
        await this.$store.dispatch("finance_click/list", params);

        this.items = await this.$store.getters["finance_click/list"];
        this.totalItems = await this.$store.getters["finance_click/listTotal"];
      } else {
        this.getListNewAppEnq(this.page, this.itemsPerPage);
      }
    },
  },
};
</script>